import {logo} from '../images'
export const devCourseData = [
  {
    learningTitle:"Foundations",
    logo:logo,
    path:"Foundations - Set Up",
    about:"This is where it all begins! A hands-on introduction to all of the essential tools you'll need to build real, working websites. You'll learn what web developers actually do. The foundations you'll need for later courses.",

    TotalNumberOfBranches:"12",
    TotalNumberCompleted:"0",
    LessonTittle:[
      {
        title:"How this Course Will Work"
      },
      {
        title:"Introduction to Web Development"
      },
      {
        title:"Motivation and Mindset"
      },
      {
        title:"Asking For Help"
      },
      {
        title:"Join the developer Communities"
      },
      {
        title:"How Does the Web Work?"
      },
      {
        title:"Installation Overview"
      },
      {
        title:"Prerequisites"
      },
      {
        title:"Text Editors"
      },
      {
        title:"Command Line Basics"
      },
      {
        title:"Setting Up Git"
      },
      {
        title:"Introduction to Git"
      },
      {
        title:"Git Basics"
      },
    ],

  },
  {
    learningTitle:"HTML Foundations",
    logo:logo,
    path:"HTML",
    about:"HTML is the universal markup language for the Web. HTML lets you format text, add graphics, create links, input forms, frames and tables, etc., and save it all in a text file that any browser can read and display.",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"8",

    TotalNumberCompleted:"0",
    LessonTittle:[
      {
        title:"Introduction to HTML and CSS"
      },
      {
        title:"Elements and Tags"
      },
      {
        title:"HTML Boilerplate"
      },
      {
        title:"Working with Text"
      },
      {
        title:"Lists"
      },
      {
        title:" Links and Images"
      },
      {
        title:"Commit Messages"
      },
      {
        title:"Project: Recipes"
      },

    ],

  },
  {
    learningTitle:"CSS Foundations",
    logo:logo,
    path:"CSS",
    about:"CSS stands for Cascading Style Sheets · CSS describes how HTML elements are to be displayed on screen, paper, or in other media ",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"9",
    TotalNumberCompleted:"0",
    LessonTittle:[
      {
        title:"CSS Foundations"
      },
      {
        title:"Inspecting HTML and CSS"
      },
      {
        title:"The Box Model"
      },
      {
        title:"Block and Inline"
      },
      {
        title:"Introduction to Flexbox"
      },
      {
        title:"Growing and Shrinking"
      },
      {
        title:"Axes"
      },
      {
        title:"Alignment"
      },
      {
        title:" Project: Landing Page"
      },

    ],
  },
  {
    learningTitle:"JavaScript Basics",
    logo:logo,
    path:"JavaScript",
    about:"JavaScript is a scripting language that enables you to create dynamically updating content, control multimedia, animate images, and pretty much everything else. (Okay, not everything, but it is amazing what you can achieve with a few lines of JavaScript code.)",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"15",
    TotalNumberCompleted:"0",
    LessonTittle:[
      {
        title:"Fundamentals Part 1"
      },
      {
        title:"Fundamentals Part 2"
      },
      {
        title:"JavaScript Developer Tools"
      },
      {
        title:"Fundamentals Part 3"
      },
      {
        title:"Problem Solving"
      },
      {
        title:"Understanding Errors"
      },
      {
        title:"Project: Rock Paper Scissors"
      },
      {
        title:"Clean Code"
      },
      {
        title:"Installing Node.js"
      },
      {
        title:"Fundamentals Part 4"
      },
      {
        title:"DOM Manipulation and Events"
      },
      {
        title:"Revisiting Rock Paper Scissors"
      },
      {
        title:"Project: Etch-a-Sketch"
      },
      {
        title:"Fundamentals Part 5"
      },
      {
        title:"Project: Calculator"
      },

      {
        title:"Conclusion: Choose Your Path Forward"
      },

    ],
  },
  {
    learningTitle:"React",
    logo:logo,
    path:"React FrameWork",
    about:"A framework is a collection of libraries, tools, rules, structures & control used to build software systems. The framework will call your code.React is a free and open-source front-end JavaScript library for building user interfaces based on UI components. It is maintained by Meta and a community of individual developers and companies.",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"2",
    TotalNumberCompleted:"0.0",
    LessonTittle:[
      {
        title:"Introduction to Frameworks"
      },
    ],
  },
  {
    learningTitle:"Nodejs/MongoDb",
    logo:logo,
    path:"React/Nodejs/MongoDb",
    about:"This path takes you through our entire JavaScript curriculum. You'll learn everything you need to know to create beautiful responsive websites from scratch using Html, Css, JavaScript, NodeJs and MongoDb.",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"2",
    TotalNumberCompleted:"0.0",
    LessonTittle:[
      {
        title:"Introduction to the Back End"
      },
    ],
  },
  {
    learningTitle:"React/Python/mongoDb",
    logo:logo,
    path:"Python and mongoDb database",
    about:"This path takes you through our entire JavaScript curriculum. You'll learn everything you need to know to create beautiful responsive websites from scratch using Html, Css, JavaScript, NodeJs and MongoDb.",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"2",
    TotalNumberCompleted:"0.0",
    LessonTittle:[
      {
        title:"How this Course Will Work"
      },
    ],
  },
  {
    learningTitle:"React/Python/MySQL",
    logo:logo,
    path:"Python and MySQL database",
    about:"This path takes you through our entire JavaScript curriculum. You'll learn everything you need to know to create beautiful responsive websites from scratch using Html, Css, JavaScript, NodeJs and MongoDb.",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"2",
    TotalNumberCompleted:"0.0",
    LessonTittle:[
      {
        title:"How this Course Will Work"
      },
    ],
  },
  {
    learningTitle:"Azure Deployement and Dev opps",
    logo:logo,
    path:"Fundermentals of Azure to Dev opps",
    about:"this path takes you from learning cloud computing to deployment to devops in Azure",
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"2",
    TotalNumberCompleted:"0.0",
    LessonTittle:[
      {
        title:"Introduction to Microsoft Azure Fundamentals"
      },
      {
        title:"cloud computing"
      },
    ],
  },
]
